<ntap-view-window target="globalDialog"></ntap-view-window>
<ng-container *ngIf="currentViewState">
    <ng-container ntapFilterViewProvider [viewName]="currentViewName" [viewState]="currentViewStateFilter">
        <ng-container appTableListGridProvider [viewName]="currentViewName" [viewState]="currentViewState" [tableColumns]="tablica" [listColumns]="lista" [gridColumns]="grid">
            <ntap-dynamic [compId]="INIT_COMP_ID" [class]="currentViewClass"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>